export const initialState = {
	messages: [],
	isLoadingMessages: false,
	isLoadedMessages: false,
	hasLoadingError: false,
};

export default initialState;
